export default __webpack_public_path__ + "images/3P.bd75add.png";